import React, {  useCallback } from "react";
import {  useSelector } from "react-redux";
import {  Form } from "semantic-ui-react";
import { AddBtn } from "../../../../commonComponents/AddBtn";
import { FormTitle } from "../../../../commonComponents/FormTitle";
import List from "../../../../commonComponents/List";
import { CustomLoader } from "../../../../commonComponents/formComponents/loader";
import AdditionalDocsDetails from "../../headerTab/additionalDocsDetails";
import { useDocument } from "../../../hooks/useDocument";
import { TranslateContext } from "../../TranslateContext";


const AdditionalDocs = (props) => {
  
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useDocument({actionType:"HEADER",tableName:"additionalDoc",containerKey:"header"})
  const additionalInfoList = useSelector((state) => state.Shipment.additionalDoc);

  const translate = React.useContext(TranslateContext).translate

  const renderItem=useCallback((item)=>{
    return <AdditionalDocsDetails
    key={item.id}
    item={item}
     updateData={updateItem}
     deleteData={deleteItem}
     saveData={saveItem}
    />
   },[updateItem,deleteItem,saveItem])
  
  
  return (
  
    <Form.Group className="float-container">
         <FormTitle boxNumber="2/2" title={translate("ADDITIONAL_DOCS")}></FormTitle>
        <List 
          dataSource={additionalInfoList}
          renderItem={renderItem}
        />
  
      { isLoading && <CustomLoader /> }
      {
       additionalInfoList?.length<99 && <AddBtn  onClick={AddItem} text={translate("ADD")}>

      </AddBtn>
}
     
      </Form.Group>
   
  );
}

export default React.memo(AdditionalDocs)
